export default __webpack_public_path__ + "static/media/bandMember-Rhys.e58dc73b.png";